import { IQuestionRepository } from "domain/contracts/question.contract";
import { FormQuestion } from "domain/entities/form-question";
import { Message } from "domain/entities/message";
import { QuestionInputFilter } from "domain/models/nimberforms-input-filters";
import { httpClient } from "infra/axios/axios-api";
import { FormQuestionPayload, FormQuestionUpdatePayload } from "presentation/components/NimberForms/FormEdit";

class QuestionRepository implements IQuestionRepository {
    async create(questions: FormQuestionPayload[]): Promise<Message<string[]>> {
        const response = await httpClient.post("/questions", {data: questions});
        return response.data;
    }

    async getAll(filter: QuestionInputFilter): Promise<Message<FormQuestion[]>> {
        const response = await httpClient.get("/question", {
            params: filter
        })
        return response.data;
    }

    async update(questions: FormQuestionUpdatePayload[]): Promise<Message<string[]>> {
        const response = await httpClient.put("/questions", {data: questions});
        return response.data;
    }

    async delete(id: string): Promise<Message<FormQuestion[]>> {
        const response = await httpClient.delete(`/question/${id}`);
        return response.data
    }
}

export default new QuestionRepository();